import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { formatMoney } from '@belong/common';
import { Text } from '../Text/Text.js';

const Money = /*#__PURE__*/React.forwardRef(function Money({
  value,
  format,
  ...rest
}, ref) {
  return jsx(Text, {
    ref: ref,
    ...rest,
    children: formatMoney(value, format)
  });
});

export { Money };
